import { render } from "./OpenPlug.vue?vue&type=template&id=4a81c550&scoped=true"
import script from "./OpenPlug.vue?vue&type=script&lang=js"
export * from "./OpenPlug.vue?vue&type=script&lang=js"

import "./OpenPlug.vue?vue&type=style&index=0&id=4a81c550&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a81c550"]])

export default __exports__